import React from "react";

export default function BsApp() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5625 3.50195C4.90463 3.50195 2.75 5.65658 2.75 8.31445V15.1895C2.75 17.8473 4.90463 20.002 7.5625 20.002H14.4375C17.0954 20.002 19.25 17.8473 19.25 15.1895V11.752C19.25 11.3723 19.5578 11.0645 19.9375 11.0645C20.3172 11.0645 20.625 11.3723 20.625 11.752V15.1895C20.625 18.6067 17.8548 21.377 14.4375 21.377H7.5625C4.14524 21.377 1.375 18.6067 1.375 15.1895V8.31445C1.375 4.89719 4.14524 2.12695 7.5625 2.12695H11C11.3797 2.12695 11.6875 2.43476 11.6875 2.81445C11.6875 3.19415 11.3797 3.50195 11 3.50195H7.5625Z"
        fill="#currentColor"
      />
      <path
        d="M22 4.87695C22 7.15513 20.1532 9.00195 17.875 9.00195C15.5968 9.00195 13.75 7.15513 13.75 4.87695C13.75 2.59878 15.5968 0.751953 17.875 0.751953C20.1532 0.751953 22 2.59878 22 4.87695Z"
        fill="#currentColor"
      />
    </svg>
  );
}
